import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { SMSI18NModule } from '../../../../assets/i18n/sms-i18n.module';
import { Observable } from 'rxjs';
import { RegistrationService } from '../../../registration.service';
import { RegistrationType } from '../../../types/registration-types';

@Component({
  imports: [CommonModule, MatDialogModule, MatButtonModule, TranslateModule, SMSI18NModule],
  templateUrl: './learn-more-modal.component.html',
  styleUrls: ['./learn-more-modal.component.scss'],
})
export class LearnMoreModalComponent {
  readonly RegistrationType = RegistrationType;
  readonly registrationType$: Observable<RegistrationType>;

  constructor(private readonly registrationService: RegistrationService) {
    this.registrationType$ = this.registrationService.getRegistrationType$();
  }
}
